export default function InertiaExample({ name }) {
  return (
    <>
    </>
  )
}
